import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[cassRefresh]'
})
export class CassRefreshDirective {
	constructor(
		private viewContainer: ViewContainerRef,
		private templateRef: TemplateRef<any>
	) {}

	@Input() set cassRefresh(condition: number | null | undefined) {
		if (condition) {
			this.viewContainer.clear();
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainer.clear();
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}
}
